(() => {
  if (!document.body.classList.contains('template-product')) return;

  const connectQuantitySelect = () => {
    document.querySelectorAll('.product-details [data-quantity-proxy]').forEach((proxy) => {
      if (!(proxy instanceof HTMLSelectElement) || proxy.dataset.connected === 'true') return;
      const input = proxy.parentElement?.querySelector('input[name="quantity"]');
      if (!(input instanceof HTMLInputElement)) return;

      proxy.value = input.value || '1';
      proxy.addEventListener('change', () => {
        input.value = proxy.value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      proxy.dataset.connected = 'true';
    });
  };

  const resetInitialVariant = () => {
    const details = document.querySelector('.product-details');
    const picker = details?.querySelector('variant-picker[ref="mainVariantPicker"]');
    const sizeInputs = picker?.querySelectorAll(
      '.variant-option--capacity input[type="radio"], .variant-option--capacity select'
    );

    if (!details || !picker || !sizeInputs?.length) return;

    sizeInputs.forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.checked = false;
        input.removeAttribute('checked');
        input.dataset.currentChecked = 'false';
        input.dataset.previousChecked = 'false';
      } else if (input instanceof HTMLSelectElement) {
        input.value = '';
      }
    });

    const variantId = details.querySelector('product-form-component input[name="id"]');
    if (variantId instanceof HTMLInputElement) variantId.value = '';

    const addButton = details.querySelector('product-form-component [ref="addToCartButton"]');
    if (addButton instanceof HTMLButtonElement) {
      addButton.disabled = true;
      addButton.dataset.zuofunAwaitingSize = 'true';
      const label = addButton.querySelector('.add-to-cart-text__content span span');
      if (label) label.textContent = 'Select a size';
    }

    const stickyButton = document.querySelector('sticky-add-to-cart [ref="addToCartButton"]');
    if (stickyButton instanceof HTMLButtonElement) stickyButton.disabled = true;

    document.body.classList.add('zuofun-awaiting-size');

    picker.addEventListener(
      'change',
      () => {
        document.body.classList.remove('zuofun-awaiting-size');
        if (addButton instanceof HTMLButtonElement) delete addButton.dataset.zuofunAwaitingSize;
      },
      { once: true }
    );
  };

  connectQuantitySelect();
  customElements.whenDefined('variant-picker').then(() => requestAnimationFrame(resetInitialVariant));
})();
